<template>
    <div>
        <div class="s_1280">
            <nav class="navbar wrapper navbar-expand-md fixed-top">
                <div class="col-4">
                    <router-link to="/home">
                        <img class="logo-img" id="logo-btn" src="images/logo.png" />
                    </router-link>
                </div>
                <div class="col-8">
                    <div class="app navigation">
                        <TopMenu></TopMenu>
                    </div>
                </div>
            </nav>

            <div class="main app">
                <div class="container-fluid wrapper">
                    <div class="row reg-box full-width-reading">

                        <div class="col-3">
                            <div class="left-bg">
                                <div class="left-links">
                                    <ul>
                                        <li><a href="#/covid">COVID - 19 Protocols</a></li>
                                        <li><a href="#/visaprocess">Visa Process</a></li>
                                        <li><a class="active" href="#/appterms">Visa Application Terms</a></li>
                                        <li><a href="#/needvisa">Do I Need a Visa</a></li>
                                        <li><a href="#/req_photo">Photo Requirements</a></li>
                                        <li><a href="#/req_passport">Passport Requirements</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-1" />

                        <div class="col-8">
                            <div class="document top98 appterms">

                                <h2>Visa Application Terms</h2>

                                <h3>GENERAL REQUIREMENTS</h3>
                                <ul>
                                    <li>Valid Passport. The passport must have left validity of at least six months and more with at least three or more unused pages.</li>
                                    <li>Recently taken photo in JPG format not bigger than 30Kb in size</li>
                                    <li>All supporting documents must be in English and uploaded as <b>ONE</b> Pdf file not bigger than 5Mb in size</li>
                                    <li>Copies of required documents must be certified.</li>
                                    <li>Applicants without name/surname should add &#39;(apostrophe) on the field to represent no name/surname</li>
                                    <li>We currently accept VISA/MasterCard for payment. The card must be enabled for online payment.</li>
                                </ul>

                                <h3>ADDITIONAL REQUIREMENTS</h3>

                                <h4>VISITORS</h4>
                                <ul>
                                    <li>Invitation letter from the host</li>
                                    <li>Certified copies of marriage/Birth Certificate for spouse and dependents</li>
                                    <li>Certified copies of host National Identity Card/ Residence and Work permit/ Exemption Certificate. Certified copies of Ordination Certificates from Religious Leaders if invited by a church</li>
                                    <li>Return VISA or Residence permit from country of residence</li>
                                    <li>For unaccompanied minors (less than 18 years), travelling without biological parents, consent letter from both parents is required.</li>
                                    <li>Return ticket</li>
                                    <li>300 Botswana Pula for single entry for a period up to 3 months</li>
                                    <li>500 Botswana Pula for multiple entry for a period up to 3 months</li>
                                    <li>1500 Pula for multiple entry for a period over 3 months up to 2 years for dependants of residents</li>
                                </ul>

                                <h4>BUSINESS</h4>
                                <ul>
                                    <li>Business profile/Invitation letter from the host or facilitator in Botswana</li>
                                    <li>Meeting schedule (If coming to attend or organize a meeting)</li>
                                    <li>Certified copies of trade license, certificate of incorporation, share certificate of host if operating a business</li>
                                    <li>500 Botswana Pula for single entry for a period up to 3 months</li>
                                    <li>1000 Botswana Pula for multiple entry for a period up to 3 months</li>
                                    <li>1500 Botswana Pula for multiple entry for a period up to 1 year</li>
                                </ul>

                                <h4>EMPLOYMENT</h4>
                                <ul>
                                    <li>Work and residence permits/approval letter</li>
                                    <li>No payment (gratis)</li>
                                </ul>

                                <h4>INVESTORS</h4>
                                <ul>
                                    <li>Copies of work and residence permits</li>
                                    <li>Certificate of incorporation, trade license, share certificate & list of directors.</li>
                                    <li>1000 Botswana Pula for multiple entry for a period up to 6 months</li>
                                    <li>2500 Botswana Pula for multiple entry for a period up to 5 year</li>
                                </ul>

                                <h4>TOURISTS</h4>
                                <ul>
                                    <li>Tour plan or copy of travel schedule</li>
                                    <li>Flight bookings</li>
                                    <li>Confirmation of bookings at hotel/lodges</li>
                                    <li><b>RETURN TICKET</b></li>
                                    <li>300 Botswana Pula for single entry for a period up to 1 months</li>
                                    <li>500 Botswana Pula for multiple entry for a period up to 3 months</li>
                                </ul>

                                <h4>TRANSIT</h4>
                                <ul>
                                    <li>Return Visa or proof of Residence and Visa from destination country</li>
                                    <li>Companies/Individual letter</li>
                                    <li>300 Botswana Pula for single entry for a period up to one week</li>
                                    <li>500 Botswana Pula for multiple entry for a period up to 3 months</li>
                                    <li>1500 Botswana Pula for multiple entry for a period up to 3 years</li>
                                </ul>

                                <h4>DIPLOMATIC, OFFICIAL</h4>
                                <ul>
                                    <li>Copy of passport</li>
                                    <li>Letter from foreign affairs</li>
                                    <li>No payment (gratis)</li>
                                </ul>

                                <h4>STUDY</h4>
                                <ul>
                                    <li>Study permit/study permit approval letter</li>
                                    <li>Admission letter from the school</li>
                                    <li>Source of funds/means of support</li>
                                    <li>No payment (gratis)</li>
                                </ul>

                                <h4>NOTES</h4>
                                <ul>
                                    <li><b>Visa fee is non-refundable. Payment does not guarantee approval.</b></li>
                                    <li>Any visa granted will be subject to compliance with the Immigration Regulations of the Republic of Botswana</li>
                                </ul>

                                <p>For best experience use the latest versions of the major web browsers</p>

                            </div>
                        </div>




                    </div>
                </div>
            </div>
        </div>
        <div class="bg white s_768">
            <div class="d-flex flex-column flex-md-row align-items-center mb-3 bg-white">
                <div class="container-fluid wrapper index">
                    <div class="nav-top row">
                        <div class="col-4">
                            <router-link to="/home">
                                <img class="logo-img" id="logo-btn" src="images/logo.png" />
                            </router-link>
                        </div>
                        <div class="col-8">
                            <div class="navigation">
                                <TopMenu :ShowContinueSubmission=true></TopMenu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top64">
                    <div class="left-links hrz-menu">
                        <ul>
                            <li><a href="#/covid">COVID - 19 Protocols</a></li>
                            <li><a href="#/visaprocess">Visa Process</a></li>
                            <li><a class="active" href="#/appterms">Visa Application Terms</a></li>
                            <li><a href="#/needvisa">Do I Need a Visa</a></li>
                            <li><a href="#/req_photo">Photo Requirements</a></li>
                            <li><a href="#/req_passport">Passport Requirements</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top16">
                    <div class="document appterms">

                        <h2 class="bt-32">Visa Application Terms</h2>

                        <h3>GENERAL REQUIREMENTS</h3>
                        <ul>
                            <li>Valid Passport. The passport must have left validity of at least six months and more with at least three or more unused pages.</li>
                            <li>Recently taken photo in JPG format not bigger than 30Kb in size</li>
                            <li>All supporting documents must be in English and uploaded as <b>ONE</b> Pdf file not bigger than 5Mb in size</li>
                            <li>Copies of required documents must be certified.</li>
                            <li>Applicants without name/surname should add &#39;(apostrophe) on the field to represent no name/surname</li>
                            <li>We currently accept VISA/MasterCard for payment. The card must be enabled for online payment.</li>
                        </ul>

                        <h3>ADDITIONAL REQUIREMENTS</h3>

                        <h4>VISITORS</h4>
                        <ul>
                            <li>Invitation letter from the host</li>
                            <li>Certified copies of marriage/Birth Certificate for spouse and dependents</li>
                            <li>Certified copies of host National Identity Card/ Residence and Work permit/ Exemption Certificate. Certified copies of Ordination Certificates from Religious Leaders if invited by a church</li>
                            <li>Return VISA or Residence permit from country of residence</li>
                            <li>For unaccompanied minors (less than 18 years), travelling without biological parents, consent letter from both parents is required.</li>
                            <li>Return ticket</li>
                            <li>300 Botswana Pula for single entry for a period up to 3 months</li>
                            <li>500 Botswana Pula for multiple entry for a period up to 3 months</li>
                            <li>1500 Pula for multiple entry for a period over 3 months up to 2 years for dependants of residents</li>
                        </ul>

                        <h4>BUSINESS</h4>
                        <ul>
                            <li>Business profile/Invitation letter from the host or facilitator in Botswana</li>
                            <li>Meeting schedule (If coming to attend or organize a meeting)</li>
                            <li>Certified copies of trade license, certificate of incorporation, share certificate of host if operating a business</li>
                            <li>500 Botswana Pula for single entry for a period up to 3 months</li>
                            <li>1000 Botswana Pula for multiple entry for a period up to 3 months</li>
                            <li>1500 Botswana Pula for multiple entry for a period up to 1 year</li>
                        </ul>

                        <h4>EMPLOYMENT</h4>
                        <ul>
                            <li>Work and residence permits/approval letter</li>
                            <li>No payment (gratis)</li>
                        </ul>

                        <h4>INVESTORS</h4>
                        <ul>
                            <li>Copies of work and residence permits</li>
                            <li>Certificate of incorporation, trade license, share certificate & list of directors.</li>
                            <li>1000 Botswana Pula for multiple entry for a period up to 6 months</li>
                            <li>2500 Botswana Pula for multiple entry for a period up to 5 year</li>
                        </ul>

                        <h4>TOURISTS</h4>
                        <ul>
                            <li>Tour plan or copy of travel schedule</li>
                            <li>Flight bookings</li>
                            <li>Confirmation of bookings at hotel/lodges</li>
                            <li><b>RETURN TICKET</b></li>
                            <li>300 Botswana Pula for single entry for a period up to 1 months</li>
                            <li>500 Botswana Pula for multiple entry for a period up to 3 months</li>
                        </ul>

                        <h4>TRANSIT</h4>
                        <ul>
                            <li>Return Visa or proof of Residence and Visa from destination country</li>
                            <li>Companies/Individual letter</li>
                            <li>300 Botswana Pula for single entry for a period up to one week</li>
                            <li>500 Botswana Pula for multiple entry for a period up to 3 months</li>
                            <li>1500 Botswana Pula for multiple entry for a period up to 3 years</li>
                        </ul>

                        <h4>DIPLOMATIC, OFFICIAL</h4>
                        <ul>
                            <li>Copy of passport</li>
                            <li>Letter from foreign affairs</li>
                            <li>No payment (gratis)</li>
                        </ul>

                        <h4>STUDY</h4>
                        <ul>
                            <li>Study permit/study permit approval letter</li>
                            <li>Admission letter from the school</li>
                            <li>Source of funds/means of support</li>
                            <li>No payment (gratis)</li>
                        </ul>

                        <h4>NOTES</h4>
                        <ul>
                            <li><b>Visa fee is non-refundable. Payment does not guarantee approval.</b></li>
                            <li>Any visa granted will be subject to compliance with the Immigration Regulations of the Republic of Botswana</li>
                        </ul>

                        <p>For best experience use the latest versions of the major web browsers</p>
                    </div>
                </div>


            </div>
            <div class="row">
                <div class="col-12">
                    <div class="placeholder top16">
                        <img src="/images/auth-bird-768.jpg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TopMenu from "./Menu";
    export default {
        components: { TopMenu },
        name: 'AppTerms',

        model: {},
        data: () => ({

        }),
        mounted() {
            this.goToTop();

        },
        computed: {

        },
        methods: {
            goToTop: function () {
                $("html, body").animate({ scrollTop: 0 }, "fast");
            },
        }
    }</script>

<style scoped>
</style>